<div class="admin-wrapper" [class.mobile-sidebar-open]="mobileOpen" [class.compact]="settings.compactMode()">
  <div class="sidebar-backdrop" (click)="mobileOpen = false"></div>
  <app-sidebar
    [collapsed]="sidebarCollapsed"
    [mobileOpen]="mobileOpen"
  />
  <div class="admin-main">
    <app-topbar (menuToggle)="onMenuToggle()" />
    <main class="admin-content">
      @if (hasNoAccess) {
        <app-no-access />
      } @else {
        <router-outlet />
      }
    </main>
  </div>
</div>

<!-- Trieon Bot hidden for now — wiki/setup/tour cover help; re-enable when a real assistant is ready -->
<!-- <app-chat-overlay /> -->
<app-setup-attention-modal
  [visible]="setupAttentionService.modalVisible()"
  (closeModal)="closeSetupModal()"
/>
<app-wiki-attention-modal
  [visible]="wikiAttentionService.modalVisible()"
  (closeModal)="closeWikiAttentionModal()"
/>
<app-tour-prompt />
<app-guided-tour />
